// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "d0fc2a0d8c07166a42c7" + ".chunk.js";
};